<template>
  <div>
    <el-upload
      :class="hideUploadEdit == true ? 'actice' : ''"
      ref="upload"
      action=""
      :http-request="handleUpload"
      list-type="picture-card"
      :limit="many"
      :file-list="initFileList"
      :on-preview="handlePictureCardPreview"
      :on-remove="handleRemove"
      :on-change="handlechange"
      :before-upload="beforeAvatarUpload"
      multiple
    >
      <i class="el-icon-plus"></i>
    </el-upload>
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>

    <!-- 图片裁剪对话框 -->
    <el-dialog
      title="图片裁剪"
      :visible.sync="cropperVisible"
      width="800px"
      :close-on-click-modal="false"
    >
      <div class="cropper-box" :style="{height: height + 'px'}">
        <vueCropper
          ref="cropper"
          :img="cropperImg"
          :outputSize="option.outputSize"
            :outputType="option.outputType"
            :info="option.info"
            :canScale="option.canScale"
            :autoCrop="option.autoCrop"
            :autoCropWidth="option.autoCropWidth"
            :autoCropHeight="option.autoCropHeight"
            :fixed="option.fixed"
            :fixedNumber="option.fixedNumber"
            :full="option.full"
            :fixedBox="option.fixedBox"
            :canMove="option.canMove"
            :canMoveBox="option.canMoveBox"
            :original="option.original"
            :centerBox="option.centerBox"
            :height="option.height"
            :infoTrue="option.infoTrue"
            :maxImgSize="option.maxImgSize"
            :enlarge="option.enlarge"
            :mode="option.mode"
        ></vueCropper>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cropperVisible = false">取消</el-button>
        <el-button type="primary" @click="cropImage">确定裁剪</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { uploadOSS } from "@/utils/oss";
import { VueCropper } from 'vue-cropper'
export default {
  components: {
    VueCropper,
  },
  props: {
    url: {
      type: Array,
      default: [],
    },
    src: {
      type: Array,
      default: [],
    },
    many: {
      type: Number,
      default: 3,
    },
    width: {
      type: Number,
      default: 300,
    },
    height: {
      type: Number,
      default: 300,
    },
  },
  data() {
    return {
      initFileList: [],
      dialogVisible: false,
      hideUploadEdit: false,
      dialogImageUrl: "",
      uploadType: "oss", //判断是本地上传  "local" 或 oss 直传 "oss"
      cropperVisible: false,
      cropperImg: '',
      tempFile: null,
      option: {
        outputSize: 1,       //裁剪生成图片的质量(可选0.1 - 1)
        outputType: 'png',  //裁剪生成图片的格式（jpeg || png || webp）
        info: true,          //图片大小信息
        canScale: true,      //图片是否允许滚轮缩放
        autoCrop: true,      //是否默认生成截图框
        autoCropWidth: 230,  //默认生成截图框宽度
        autoCropHeight: 150, //默认生成截图框高度
        fixed: true,         //是否开启截图框宽高固定比例
        fixedNumber: [1.53, 1], //截图框的宽高比例
        full: false,         //false按原比例裁切图片，不失真
        fixedBox: false,      //固定截图框大小，不允许改变
        canMove: false,      //上传图片是否可以移动
        canMoveBox: true,    //截图框能否拖动
        original: false,     //上传图片按照原始比例渲染
        centerBox: false,    //截图框是否被限制在图片里面
        height: true,        //是否按照设备的dpr 输出等比例图片
        infoTrue: false,     //true为展示真实输出图片宽高，false展示看到的截图框宽高
        maxImgSize: 3000,    //限制图片最大宽度和高度
        enlarge: 1,          //图片根据截图框输出比例倍数
        mode: '230px 150px'  //图片默认渲染方式
      }
    };
  },
  created() { 
    this.option.autoCropWidth = this.width;
    this.option.autoCropHeight = this.height;
    this.option.mode = this.width + 'px ' + this.height + 'px';
    this.option.fixedNumber = [this.width / this.height, 1];
  },
  watch: {
    src: {
      immediate: true,
      handler(e, r) {
       let imgList = []
        e.forEach((it,ind)=>{
          let obj = {
                name: it.name || ind,
                url: it.url || it,
                uid: it.uid || ind,
          }
          imgList.push(obj)
        })
        this.initFileList = imgList
      },
    },
  },
  methods: {
    beforeAvatarUpload(file){
        const isJPG = file.type == 'image/jpeg' || file.type == 'image/png';
        if (!isJPG) {
          this.$message.error('请上传正确的图片格式！');
        }
        return isJPG
    },    
    //图片多选
    handlechange(file, fileList) {
      this.checkLimit(fileList);
    },
    checkLimit(filelist) {
      if (filelist.length >= this.many) {
        this.hideUploadEdit = true;
      } else {
        this.hideUploadEdit = false;
      }
    },
    // 商品主图 图片放大
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true;
    },
    handleRemove(file, item) {
      const index = this.initFileList.findIndex((i) => i.url === file.url);
      this.initFileList.splice(index, 1);
      this.$emit("update:url", this.initFileList);
      this.checkLimit(item);
    },
    // 打开裁剪对话框
    openCropper(file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        this.cropperImg = e.target.result;
        this.tempFile = file;
        this.cropperVisible = true;
      };
      reader.readAsDataURL(file);
    },
    // 裁剪图片
    cropImage() {
      this.$refs.cropper.getCropBlob((blob) => {
        // 创建新的File对象用于上传
        const croppedFile = new File([blob], this.tempFile.name, {
          type: blob.type
        });
        this.cropperVisible = false;
        // 调用上传方法
        this.performUpload(croppedFile);
      });
    },
    handleUpload({ file }) {
      // 打开裁剪对话框
      this.openCropper(file);
    },
    // 上传图片
    performUpload(file) {
      try {
        const loading = this.$loading({
          lock: true,
          text: "上传中,请稍后...",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        if (this.uploadType == "oss") {
          uploadOSS(file).then((res) => {
            if (res) {
              var url = {
                name: file.name,
                url: res,
                uid: file.uid,
              };
              this.initFileList.push(url);
              this.$emit("update:url", this.initFileList);
            } else {
              this.$message.warning("上传失败，请重试");
            }
            loading.close();
          });
        } else {
          var formData = new FormData();
          formData.append("file", file);
          formData.append("moduleName", file.name.split(".")[0]);
          this.$Apis.verificationImg(formData).then((res) => {
            if (res.code == 200) {
              var url = {
                name: file.name,
                url: res.data,
                uid: file.uid,
              };
              this.initFileList.push(url);
              this.addData.imgUrl = this.initFileList;
              this.$emit("update:url", this.imageUrl);
            } else {
              this.$message.warning(res.msg);
            }
            loading.close();
          });
        }
      } catch (error) {}
    },
  },
};
</script>

<style>
.cropper-box {
  width: 100%;
  height: auto;
}
</style>